import React from 'react';

const Title = (props) => {
    const styles = {
        text: {
            color: 'white',
            marginTop: 10,
            marginBottom: 0
        }
    }

    return <h2 style={styles.text}>{props.text}</h2>;
}

export default Title;